import Box from '@mui/material/Box';
import { HelpTooltip } from 'components/ui/common/HelpTooltip/HelpTooltip.js';

import {
  FieldAsterisk,
  FieldDescription,
  FieldLabel,
} from './FormLabel.styled.js';

export interface TitleFieldProps {
  title: string;
  required?: boolean;
  description?: string;
  tooltip?: string;
}

export const TitleField = ({ title, required, description, tooltip }: TitleFieldProps) => {
  if (!title) {
    return null;
  }

  const label = (
    <div>
      <FieldLabel sx={{ pt: 0.5 }} data-sentry-unmask>
        {title}
        {' '}
        {required && <FieldAsterisk>*</FieldAsterisk>}
      </FieldLabel>
      {description && <FieldDescription data-sentry-unmask>{description}</FieldDescription>}
    </div>
  );

  if (!tooltip) {
    return label;
  }

  return (
    <Box display="flex" alignItems="center">
      {label}
      <Box display="flex" pt={0.5} pl={0.8}>
        <HelpTooltip title={tooltip} />
      </Box>
    </Box>
  );
};
